$(document).on("click", "*[data-send-message]", function (e) {
  var button, recipient_ids;
  e.preventDefault();
  button = $(e.currentTarget);
  recipient_ids = button.data("recipient-id");
  if (!button.data('message-view')) {
    button.data('message-view', new Messages.ModalFormView(recipient_ids));
  }
  return button.data('message-view').show();
});